<fuse-loading-bar></fuse-loading-bar>

<!-- Navigation -->
<ng-container *ngIf="isScreenSmall">
  <fuse-vertical-navigation class="dark bg-gray-900 print:hidden" [mode]="'over'" [name]="'mainNavigation'"
    [navigation]="navigation.default" [opened]="false">

    <ng-container fuseVerticalNavigationContentHeader>
      <div class="flex items-center h-20 pt-6 px-8">
        <img class="w-24" src="assets/images/logo/logo-text-on-dark.png" alt="Logo image" />
      </div>
    </ng-container>

  </fuse-vertical-navigation>
</ng-container>


<!-- Wrapper -->
<div class="flex flex-col flex-auto items-center w-full min-w-0 bg-gray-200 dark:bg-card">

  <!-- Header -->
  <div
    class="relative flex flex-col flex-0 justify-center w-full h-14 sm:h-16 md:h-28 overflow-hidden z-49 shadow-lg dark:shadow-none print:hidden">

    <div class="relative dark flex flex-auto justify-center w-full px-4 md:px-6 lg:px-8"
      style="background: linear-gradient(135deg, #1e2241 0%, #262b52 55%, #1a1d38 100%);">

      <div class="absolute inset-x-0 top-0 h-[2px]"
        style="background: linear-gradient(90deg, #4f5b93 0%, #7c89c9 50%, #4f5b93 100%); opacity: 0.6;">
      </div>

      <div class="flex items-center w-full max-w-[1800px]">

        <ng-container *ngIf="!isScreenSmall">
          <div class="flex items-center min-w-0 flex-1">

            <div class="flex items-center flex-shrink-0">
              <img class="w-24" src="assets/images/logo/logo-text-on-dark.png" alt="Logo image" />
            </div>

            <div class="w-px h-8 bg-white/10 mx-5"></div>

            <div class="font-medium text-sm sm:text-base md:text-lg lg:text-xl
             tracking-wide text-white/90 truncate">
              Sistema de Inventário de Gases de Efeito Estufa Rural - SIGEER
            </div>

          </div>

          <!-- Detalhes do inventário -->
          <button *ngIf="isNavegacaoHabilitada" type="button" (click)="abrirMenu()" class="group flex items-center gap-2 ml-6
            px-4 py-2.5
            rounded-xl
            text-white/90
            bg-white/10
            border border-white/10
            backdrop-blur-sm
            transition-all duration-300
            hover:bg-white/20
            hover:border-white/20
            hover:shadow-lg
            active:scale-95">

            <span class="font-medium text-sm">
              Navegação do inventário
            </span>

            <mat-icon class="text-white/60 text-[20px]
           transition-transform duration-300
           group-hover:translate-x-1" matTooltip="Navegação do inventário" matTooltipPosition="above">
              chevron_right
            </mat-icon>
          </button>
        </ng-container>

        <ng-container *ngIf="isScreenSmall">
          <div class="flex items-center justify-between w-full gap-2">
            <div class="flex items-center">
              <img class="w-20" src="assets/images/logo/logo-text-on-dark.png" alt="Logo image" />
            </div>

            <div class="flex items-center gap-1">
              <button *ngIf="isNavegacaoHabilitada" type="button" (click)="abrirMenu()"
                mat-icon-button
                class="!rounded-xl hover:!bg-white/10 transition-colors duration-200"
                matTooltip="Navegação do inventário"
                matTooltipPosition="below">
                <mat-icon class="text-white/90">menu_open</mat-icon>
              </button>

              <button mat-icon-button class="!rounded-xl hover:!bg-white/10 transition-colors duration-200"
                (click)="toggleNavigation('mainNavigation')">
                <mat-icon [svgIcon]="'heroicons_outline:menu'" class="text-white/90"></mat-icon>
              </button>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
  </div>

  <!-- Conteúdo -->
  <div class="flex justify-center w-full bg-white dark:bg-gray-900 flex-auto" [ngClass]="{
      'pt-20': !isScreenSmall && !exibirNavegacaoHorizontal
    }">

    <mat-sidenav-container class="relative w-full h-full bg-transparent">

      <mat-sidenav-content class="h-full" [ngClass]="isMapaRoute ? 'overflow-hidden' : 'overflow-auto'">

        <div class="flex justify-center w-full h-full">

          <div class="w-full h-full" [ngClass]="isMapaRoute
              ? 'max-w-none px-0'
              : 'max-w-[1800px] px-4 md:px-6 lg:px-8'">

            <router-outlet></router-outlet>

          </div>

        </div>

      </mat-sidenav-content>

    </mat-sidenav-container>

  </div>


  <!-- Footer -->
  <div class="relative flex flex-0 justify-center w-full px-6 md:px-8 z-49 border-t bg-card print:hidden">

    <div class="flex items-center w-full max-w-[1800px] h-14 sm:h-20">

      <span class="font-medium text-secondary">
        Desenvolvido por CampoTech - Polo Sebrae Agro &copy;
        {{ currentYear }}
      </span>

    </div>

  </div>

</div>

<!-- Drawer global -->
<div class="fixed inset-0 z-[9999] pointer-events-none" [@drawerOverlay]="isDrawerMenuVisible ? 'open' : 'closed'">

  <!-- Backdrop -->
  <div class="absolute inset-0 bg-black/40 pointer-events-auto" (click)="closeDrawerMenu()">
  </div>

  <!-- Drawer -->
  <aside class="absolute top-0 right-0 h-full
         w-full sm:w-[360px] md:w-[400px]
         bg-white dark:bg-gray-800
         shadow-2xl
         pointer-events-auto" [@drawerPanel]="isDrawerMenuVisible ? 'open' : 'closed'">

    <app-drawer-menu (closeMenu)="closeDrawerMenu()" [latitude]="latitude" [longitude]="longitude"
      [idInventario]="idInventario">
    </app-drawer-menu>

  </aside>
</div>

<!-- Navegação flutuante -->
<div #floatingNav class="fixed top-4 left-0 right-0 flex justify-center z-[100] px-4 pointer-events-none print:hidden"
  [class.!hidden]="isScreenSmall || exibirNavegacaoHorizontal">

  <div
    class="flex items-center w-full max-w-[1800px] h-14 px-2 lg:px-4 rounded-2xl shadow-2xl border border-white/20 pointer-events-auto"
    style="background-color: rgba(255, 255, 255, 0.75); backdrop-filter: blur(12px); -webkit-backdrop-filter: blur(12px);">

    <fuse-horizontal-navigation class="w-full -mx-4 lg:-mx-2" [name]="'mainNavigation'"
      [navigation]="navigation.horizontal">
    </fuse-horizontal-navigation>

  </div>
</div>